import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import AmazonSESForm from '../forms/amazon-ses-form';
import { amazonSESConnectorFormValidationSchema } from '../schema/amazonSESConnector.js';

export default function AmazonSESConnectorNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Amazon SES Connector Node Details',
        altText: 'Amazon SES Connector Node',
        defaultLabel: 'Amazon SES Connector Node',
      }}
    >
      <CommonNode
        FormComponent={AmazonSESForm}
        schemaResolver={amazonSESConnectorFormValidationSchema}
      />
    </NodeProvider>
  );
}
